import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b33c464"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "polygon-container" }
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = { id: "escape-path-mask--1" }
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = ["d"]
const _hoisted_6 = ["d"]
const _hoisted_7 = ["d"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M10 7.12728L0 4.37114e-07L6.11959e-07 14L10 7.12728Z" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "loading-inner" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "progress" }
const _hoisted_13 = { class: "percentage" }

import { ref, onMounted, onUnmounted, computed, nextTick, watch } from 'vue';
import { useI18n } from 'vue-i18n'
import gsap from 'gsap'
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"
import { MotionPathPlugin } from "gsap/MotionPathPlugin"

import { useAppState, useGameState } from '@/services/composition'

import UIBrands from '@/components/UIBrands/UIBrands.vue';
import Delay from '@/core/Delay';
import FrontResources from '@/core/FrontResources';
import lerp from '@/utils/Lerp';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

gsap.registerPlugin(DrawSVGPlugin)
gsap.registerPlugin(MotionPathPlugin)

const { t } = useI18n()
const { send, state: appState } = useAppState()

const root = ref(null)

const escapePathData = ref(
  {
    viewBox: { minX: 0, minY: 0, width: 0, height: 0 },
    polygon: { points: "" },
    path: { d: '' }
  }
)

let rafId:number
const progress = ref(0)
const resourceProgress = computed(() => {
  return (appState.value.context.glCurrentLoad + appState.value.context.frontCurrentLoad) / (appState.value.context.glTotalLoad + appState.value.context.frontTotalLoad)
})

const percentage = computed(() => {
  return `${(resourceProgress.value * 100).toFixed(0)}%`
})

const canProgress = ref(true)
watch(resourceProgress, (value) => {
  if (canProgress.value) {
    gsap.to(progress, { value, duration: 0.2, ease: 'quint.out' })
  }
})

watch(progress, (progress) => {
  progressTL.value?.progress(progress)
  if (progress === 1) {
    leave()
  }
})

const onEnter = (el: HTMLElement, onComplete: gsap.Callback) => {
  const head = (escapePathHead.value as SVGGElement)

  const tl = gsap.timeline({ onComplete })

  tl.fromTo(el, { opacity: 0 }, { opacity: 1, duration: 1 })
  tl.addLabel('start')
  tl.fromTo( head, { opacity: 0 }, { opacity: 1, duration: 0.3, ease: 'quint.in' }, 'start')
}

const onAfterEnter = () => {
  canProgress.value = true
}

const leave = () => {
  const head = (escapePathHead.value as SVGGElement)
  const tl = gsap.timeline({ onComplete: () => { send('LOADED') } })
  tl.to( head, { opacity: 0, duration: 0.3, ease: 'quint.in' })
  tl.to( root.value, { opacity: 0, duration: 1 })
}

const resize = async () => {
  await nextTick()
  const winW = window.innerWidth
  const winH = window.innerHeight
  const padding = winW > 414 ? 24 : 16
  const bLevelSize = winW > 414 ? 224 : 96
  escapePathData.value = {
    viewBox: {
      minX: 0,
      minY: 0,
      width: winW,
      height: winH
    },
    //points: `${padding} ${padding}, ${winW - padding} ${padding}, ${winW - padding} ${winH - bLevelSize - padding}, ${winW - padding - bLevelSize} ${winH - padding}, ${padding} ${winH - padding}`
    polygon: { points: `${winW - padding} ${winH - bLevelSize - padding} ${winW - padding - bLevelSize} ${winH - padding} ${padding} ${winH - padding} ${padding} ${padding} ${winW - padding} ${padding}` },
    path: {
      d: `M${winW - padding} ${winH - bLevelSize - padding} L${winW - padding - bLevelSize} ${winH - padding} L${padding} ${winH - padding} L${padding} ${padding} L${winW - padding} ${padding}Z`
    }
  }
}

const progressTL = ref(null)
const escapePathInvisible = ref(null)
const escapePathMask = ref()
const escapePathHead = ref()
const createProgressTL = () => {
  const path = (escapePathMask.value as SVGPathElement)
  const head = (escapePathHead.value as SVGGElement)

  progressTL?.value && progressTL.value.kill()

  const $ = gsap.utils.selector(root.value)
  const tl = gsap.timeline({ paused: true })

  tl.addLabel('escapePath', 0.2)
  
  tl.to( head, {
      motionPath: {
        path: escapePathInvisible.value,
        align: escapePathInvisible.value,
        alignOrigin: [0.5, 0.5],
        autoRotate: true,
      },
      duration: 2.5,
    },
    'escapePath'
  )

  .fromTo( path, { 
      drawSVG: '0 100%', 
    }, {
      drawSVG: '100% 100%',
      duration: 2.5,
    }, 
    'escapePath'
  )

  // .fromTo([...$('#escape-path')], {
  //     opacity: 0
  //   }, {
  //     opacity: 1,
  //     duration: 1,
  //     ease: 'none'
  //   },
  //   'escapePath+=0.6'
  // )

  // .to( head, { opacity: 0, duration: 0.3, ease: 'quint.out' }, '-=0.3')

  progressTL.value = tl
}

onMounted(async() => {
///////////////
////////////////////////////////////////////////////////
////////////////////
///////////////////
//////////
///
////////////
  window.addEventListener('resize', resize)
  resize()
  createProgressTL()
})

onUnmounted(() => {
  cancelAnimationFrame(rafId)
  window.removeEventListener('resize', resize)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    onEnter: onEnter,
    onAfterEnter: onAfterEnter,
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "loading",
        ref_key: "root",
        ref: root
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createElementBlock("svg", {
            id: "escape-path",
            viewBox: `${escapePathData.value.viewBox.minX} ${escapePathData.value.viewBox.minY} ${escapePathData.value.viewBox.width} ${escapePathData.value.viewBox.height}`,
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("defs", null, [
              _createElementVNode("mask", _hoisted_3, [
                _createElementVNode("rect", {
                  x: "0",
                  y: "0",
                  width: escapePathData.value.viewBox.width,
                  height: escapePathData.value.viewBox.height,
                  fill: "white"
                }, null, 8, _hoisted_4),
                _createElementVNode("path", {
                  ref_key: "escapePathMask",
                  ref: escapePathMask,
                  d: escapePathData.value.path.d,
                  fill: "none",
                  "stroke-width": "4",
                  stroke: "black"
                }, null, 8, _hoisted_5)
              ])
            ]),
            _createElementVNode("path", {
              mask: "url(#escape-path-mask--1)",
              class: "dashed",
              ref: "escapePathLine",
              d: escapePathData.value.path.d,
              fill: "none",
              "stroke-width": "2"
            }, null, 8, _hoisted_6),
            _createElementVNode("path", {
              ref_key: "escapePathInvisible",
              ref: escapePathInvisible,
              d: escapePathData.value.path.d,
              fill: "none",
              "stroke-width": "4",
              stroke: "none"
            }, null, 8, _hoisted_7),
            _createElementVNode("g", {
              ref_key: "escapePathHead",
              ref: escapePathHead
            }, _hoisted_9, 512)
          ], 8, _hoisted_2))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(UIBrands, { class: "brands--loading" }),
          _createElementVNode("div", {
            class: "title",
            innerHTML: _unref(t)('loader.wait')
          }, null, 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(percentage)), 1)
        ])
      ], 512)
    ]),
    _: 1
  }))
}
}

})